<template>
  <b-modal id="alert-popup1"
           size="md"
           modal-class="client-details-modal"
           centered
           hide-header-close
           title="Your Current Plan"
           hide-footer>
    <template #modal-header>
      <div class="view-clients-header">
        <b-button variant="close-btn"  @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <div class="alert-popup">
      <p class="mb-4 text-center agreement-heading"><strong>Do you want to confirm below plans?</strong></p>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Plans</th>
              <th>Renewal Rate</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ currentPlan.web_display_name }}</td>
              <td>{{ currentPlan.price | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center">
        <button class="accept-btn" @click="keepPlan">
          {{ isKeep ? "Accepting..." : "Accept" }}
        </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import Api from "@/resource/Api";
export default {
  name: "DashboardEnrollmentCurrentPlanModal",
  props: {
    currentPlan: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    isKeep: false,
  }),
  methods: {
    keepPlan() {
      let url = `v2/keep-plan`;
      let data = {
        current_plan_policy_id: this.currentPlan.plan_policy_id,
      };
      this.isKeep = true;
      Api.put(url, data)
        .then((res) => {
          this.$notify(res.data.message, 'success')
          this.$bvModal.hide("alert-popup1");
          this.$bvModal.hide("renewalPlanSwitchModal");
        })
        .catch((err) => {
          console.log(err)
          this.$notify('Something went wrong', 'error')
        })
        .finally(() => {
          this.isKeep = false;
        });
    },
    closeModal() {
      this.$bvModal.hide('alert-popup1')
    }
  },
};
</script>